import Input from "~/components/Input";

type StepReviewInfoProps = {
  form?: any;
};

const StepReviewInfo = ({ form }: StepReviewInfoProps) => {
  return (
    <div className="flex flex-col justify-center items-center gap-5">
      <p className="text-2xl font-medium text-center">About you</p>
      <div className="flex gap-2 w-full justify-between items-center flex-col">
        <Input
          required
          label="Email"
          placeholder="Enter your Email"
          className="w-full"
          type="email"
          {...form.getFieldProps("summary")}
          error={form?.touched?.summary && form?.errors?.summary}
        />
        <Input
          //   required
          label="Full name"
          placeholder="Enter your name"
          className="w-full"
          {...form.getFieldProps("name")}
          error={form?.touched?.name && form?.errors?.name}
        />
      </div>
    </div>
  );
};

export default StepReviewInfo;
